// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__gr-1h","content":"styles_content__1c1Bs","checkbox":"styles_checkbox__1s4P8","checkboxLabel":"styles_checkboxLabel__wR0Op"};